import apiClient from "@/services/axios";
import JsPDF from "jspdf";
import "jspdf-autotable";
import moment from "moment";
const _ = require('lodash');
async function imageUrlToBase64(url) {
  try {
    if (!url) throw new Error("no URL");
    //if (!url || !(typeof url == "string")) throw new Error("no URL");
    const response = await fetch(url);
    const blob = await response.blob();

    return await new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // this is the Base64 string
      reader.onerror = reject;
      reader.readAsDataURL(blob);
    });
  } catch (error) {
    return null;
  }
}
function fixArabicParentheses(text) {
  if (/[\u0600-\u06FF\u0750-\u077F\u08A0-\u08FF]/.test(text)) {
    let tmp = text.replace(/\(/g, "﴿").replace(/\)/g, "﴾"); // Arabic-friendly parentheses
    return tmp.replace(/\﴿/g, ")").replace(/\﴾/g, "("); // Arabic-friendly parentheses
  }
  return text;
}
const formatMarkNumber = (value, noDecimal = false, showExampt = false) => {
  if (value == null || value === "" || isNaN(Number(value))) {
    return showExampt ? "معفی" : "--.--";
  }
  const num = Number(value);
  const integerPart = Math.floor(Math.abs(num));
  const decimalPart = noDecimal ? "" : (Math.abs(num) % 1).toFixed(2).substring(1); // Get .XX part
  const formattedInteger = integerPart.toString().padStart(2, "0");
  return formattedInteger + decimalPart;
};
export default {
  data() {
    return {
      printLoading: false,
      govLogoBase64: null,
      pdfBlob: null,
    };
  },
  async created() {
    this.govLogoBase64 = await imageUrlToBase64("/resources/images/govImg.png");
  },
  methods: {
    /**
     * Fetch student moyennes data from API
     * @param {string} studentId - Student ID
     * @param {string|number} trimester - Trimester (1, 2, or 3)
     * @returns {Promise<Object>} Student moyennes data
     */
    async fetchStudentMoyennes(studentId, trimester) {
      try {
        const response = await apiClient.get(
          `/bulletin/college/printing/moyennes/${studentId}/${trimester}`
        );
        return response.data;
      } catch (error) {
        this.$message.error(
          this.$t("error.erreur") || "Error fetching student data"
        );
        throw error;
      }
    },

    /**
     * Fetch all students moyennes data for a class from API
     * @param {string} classRoomId - Classroom ID
     * @param {string|number} trimester - Trimester (1, 2, or 3)
     * @returns {Promise<Object>} All students moyennes data
     */
    async fetchAllStudentsMoyennes(classRoomId, trimester) {
      try {
        const response = await apiClient.get(
          `/bulletin/college/printing/moyennes/all/${classRoomId}/${trimester}`
        );
        return response.data;
      } catch (error) {
        this.$message.error(
          this.$t("error.erreur") || "Error fetching all students data"
        );
        throw error;
      }
    },

    /**
     * Generate and download PDF for student bulletin
     * @param {string} studentId - Student ID
     * @param {string|number} trimester - Trimester (1, 2, or 3)
     */
    async printStudentBulletin(studentId, trimester, language = "ar") {
      if (!studentId || !trimester) {
        this.$message.warning(
          this.$t("bulletin.selectStudentAndTrimester") ||
            "Please select a student and trimester"
        );
        return;
      }

      this.printLoading = true;
      try {
        // Fetch data from API
        const data = await this.fetchStudentMoyennes(studentId, trimester);

        if (!data || !data.bulletinData) {
          this.$message.error(
            this.$t("error.erreur") || "No data available for printing"
          );
          return;
        }

        // Generate PDF
        let pdfBlob
        if (language === "ar") pdfBlob = await this.generatePDF(data, studentId, trimester, false);
        else pdfBlob = await this.generatePdfFr(data, studentId, trimester, false);
        this.pdfBlob = pdfBlob;
        this.$message.success(
          this.$t("bulletin.printSuccess") || "PDF generated successfully"
        );
      } catch (error) {
        console.log(error);
        this.$message.error(
          this.$t("error.erreur") || "Error generating PDF"
        );
      } finally {
        this.printLoading = false;
      }
    },

    /**
     * Generate PDF document from student data in Tunisian bulletin format
     * @param {Object|Array} data - Student moyennes data from API or array of student data
     * @param {string} studentId - Student ID
     * @param {string|number} trimester - Trimester
     * @param {boolean} preview - Whether to return blob URL for preview
     * @param {boolean} isMultipleStudents - Whether generating multiple students in one PDF
     */
    async generatePDF(data, studentId, trimester, preview = false, isMultipleStudents = false) {
      // Handle multiple students case - data is an array of student data
      let doc
      if (isMultipleStudents) {
        if (isMultipleStudents === true) {
          doc = new JsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
          });
          isMultipleStudents = doc;
        }
        else {
          doc = isMultipleStudents;
          doc.addPage();
        }
      }
      else {
        doc = new JsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });
      }
      // Handle multiple students case - data is an array of student data
      if (isMultipleStudents && Array.isArray(data)) {
        return await this.generateMultiplePdfAr(data, trimester, preview);
      }

    // Single student case - original logic
      const { bulletinData, bulletinConfig, rank, subjectsMinMaxAvg, numberOfStudents } = data;
      const { student, subjectMoyennes, generalMoyenne, trimester: dataTrimester, level } =
        bulletinData;

      // Get school information
      const schoolDetails = this.user?.building?.find(
        (el) => el.dbName === this.settings?.activeBuilding
      ) || {};
      const schoolNameAr = schoolDetails?.ArabicName || "";
      const schoolNameFr = schoolDetails?.name || "";
      const delegation = schoolDetails?.delegeRegional || "";
      const schoolAddress = schoolDetails?.address || "";
      const schoolGovNumber = schoolDetails?.govNumber || "";

      // Get school year
      const schoolYear = this.settings?.schoolarYears?.find(
        (el) => el._id === this.settings?.activeSchoolarYear
      );
      const startYear = schoolYear?.start ? new Date(schoolYear.start).getFullYear() : new Date().getFullYear();
      const endYear = schoolYear?.end ? new Date(schoolYear.end).getFullYear() : new Date().getFullYear() + 1;
      const schoolarYearName = `${startYear}/${endYear}`;

      let schoolTypeText = level <= 9 ? " - المدرسة الاعدادية الخاصة" : " - المعهد الخاص ";
      schoolTypeText += schoolNameAr ? schoolNameAr : "";
      schoolTypeText += schoolGovNumber ? ` - ${schoolGovNumber}` : "";


      // Get trimester name in Arabic
      const trimesterNames = {
        1: "الثلاثي الأول",
        2: "الثلاثي الثاني",
        3: "الثلاثي الثالث",
      };
      const trimesterNameAr = trimesterNames[dataTrimester] || `الثلاثي ${dataTrimester}`;

      // Get student's classroom info (we need to get this from the component)
      const selectedClasse = this.selectedClasse || this.$parent?.selectedClasse;
      const classesList = this.classes || this.$parent?.classes || [];
      const className = classesList.find(c => c._id === selectedClasse)?.name || "";


      // Create PDF document
      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = doc.internal.pageSize.getHeight();
      let leftMargin = 15;
      let rightMargin = pdfWidth - 15;
      let rightMargin2 = pdfWidth - 45;
      const pdfCenter = pdfWidth / 2;
      // define line of each element
      const lines = {
        0: 10,
        1: 17.5,
        2: 25,
        3: 30,
        4: 35,
        5: 40,
        6: 45,
        7: 50,
        8: 55,
        9: 60,
      }

      let yPosition = lines[0];
      let text = ""
      let textWidth = 0;
      // Set font to Amiri
      //doc.setFont("Amiri", "normal");
      doc.setFont("Amiri", "normal");

      // Header Section
      doc.setFontSize(12);
      doc.setTextColor(0, 0, 0);

      // ######## line 1 ########
      // Tun Gov
      text = "الجمهورية التونسية";
      textWidth = doc.getTextWidth(text);
      const govWidth = textWidth
      const govX = rightMargin - textWidth
      doc.text(text, govX, yPosition);

      // Gov logo 
      const govLogo = this.govLogoBase64;
      doc.addImage(govLogo, "PNG", pdfCenter - 5, yPosition - 7.5, 10, 10);

      // gov office
      text = "المندوبية الجهوية للتربية"
      text += delegation ? ` بـ${delegation}` : "................بـ";
      doc.text(text, leftMargin, yPosition);


      // ######## line 2 ########
      yPosition = lines[1];
      doc.setFont("Amiri", "Bold");

      // ministry
      text = "وزارة التربية";
      textWidth = doc.getTextWidth(text);
      const ministryX = govX + govWidth / 2 - textWidth / 2 // to make gov and ministry center aligned
      doc.text(text, ministryX, yPosition);

      // bulletin Name
      text = "بطاقة النتائج المدرسية";
      textWidth = doc.getTextWidth(text);
      doc.text(text, pdfCenter - textWidth / 2, yPosition);

      // school Name
      text = schoolTypeText;
      textWidth = doc.getTextWidth(text);
      doc.text(text, leftMargin, yPosition);

      // ######## line 3 ########
      yPosition = lines[2];
      doc.setFont("Amiri", "normal");
      text = `السنة الدراسية : ${schoolarYearName}`;
      textWidth = doc.getTextWidth(text);
      doc.text(text, leftMargin, yPosition);

      // trimester
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(16);
      text = trimesterNameAr
      textWidth = doc.getTextWidth(text);
      doc.text(text, pdfCenter - textWidth / 2, yPosition);


      // ######## line 4 ########
      doc.setFont("Amiri", "normal");
      doc.setFontSize(10);
      // full name title
      yPosition = lines[3];
      doc.setFont("Amiri", "normal");
      text = ":الاسم واللقب"
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin - textWidth, yPosition);
      // full name
      const studentName = student.fullName || student.fullNameFr || "غير متوفر";
      text = studentName;
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin2 - textWidth, yPosition);


      // ######## line 5 ########
      yPosition = lines[4];

      // classroom title
      text = ":         القسم"
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin - textWidth, yPosition);
      // classroom name
      text = className || "----";
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin2 - textWidth, yPosition);


      // ######## line 6 ########
      yPosition = lines[5];
      // birth date title
      text = ": تاريخ الولادة"
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin - textWidth, yPosition);
      // birth date
      const birthDateStr = student.birthDate ? moment(student.birthDate).format("DD/MM/YYYY") : "----/--/--";
      text = birthDateStr;
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin2 - textWidth, yPosition);


      // ######## line 7 ########
      yPosition = lines[6];
      // number of students title
      text = ": عدد التلاميذ"
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin - textWidth, yPosition);
      // number of students
      text = numberOfStudents ? String(numberOfStudents) : "--";
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin2 - textWidth, yPosition);

      // ######## line 8 ########
      yPosition = lines[7];
      // rank number title
      text = ":  العدد الرتبي"
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin - textWidth, yPosition);
      // rank number
      text = ""
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin2 - textWidth, yPosition);

      // ######## line 9 ########
      yPosition = lines[8];
      // registration number title
      text = ":رقم التسجيل"
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin - textWidth, yPosition);
      // registration number
      text = student.identityNumber ? String(student.identityNumber) : "----";
      textWidth = doc.getTextWidth(text);
      doc.text(text, rightMargin2 - textWidth, yPosition);


      // ######## line 10 ########
      yPosition = lines[9];
      // ######## Table of marks ########

      //for 
      const headStyles = {
        font: "Amiri",
        fontStyle: "Bold",
        fontSize: 6,
        halign: "center",
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        fillColor: [200, 200, 200],
        textColor: [0, 0, 0],
      }
      const tableData =
        [
          [
            {
              content: "الملاحظات",
              rowSpan: 2,
              styles: headStyles,
            },
            {
              content: "الحاصل",
              rowSpan: 2,
              styles: headStyles,
            },
            {
              content: "الرتبة",
              rowSpan: 2,
              styles: headStyles,
            },
            {
              content: "المعدل\nالثلاثي",
              rowSpan: 2,
              styles: headStyles,
            },
            {
              content: "فرض\nتأليفي",
              rowSpan: 2,
              styles: headStyles,
            },
            {
              content: "فروض مراقبة",
              colSpan: 2,
              styles: headStyles,
            },
            {
              content: "اختبار\nكتابي",
              rowSpan: 2,
              styles: headStyles,
            },
            {
              content: "اشغال\nتطبيقية",
              rowSpan: 2,
              styles: headStyles,
            },
            {
              content: "شفاهي",
              rowSpan: 2,
              styles: headStyles,
            },
            {
              content: "الضارب",
              rowSpan: 2,
              styles: headStyles,
            },
            {
              content: "المواد",
              rowSpan: 2,
              styles: { ...headStyles, halign: "right" },
            },
          ],
          [
            {
              content: "ف.م.2",
              styles: headStyles,
            },
            {
              content: "ف.م.1",
              styles: headStyles,
            },
          ]
        ];

      const tableRawData = _.zip(bulletinData.subjectMoyennes, bulletinConfig)

      const bodyStyles = {
        font: "Amiri",
        fontStyle: "Bold",
        fontSize: 7,
        halign: "center",
        valign: "middle",
        lineColor: [0, 0, 0],
        lineWidth: 0.1,
        fillColor: [255, 255, 255],
      }

      const getMarkValue = (markType, subjectData, enabledMarkTypes, showExampt = false) => {
        if (enabledMarkTypes.includes(markType)) {
          // check the array exists in .marks and not empty
          if (subjectData?.marks?.[markType] && subjectData?.marks?.[markType].length > 0) {
            // check if the array has one or two elements
            if (subjectData?.marks?.[markType].length === 1) {
              return formatMarkNumber(subjectData?.marks?.[markType][0], false, showExampt);
            } else {
              return formatMarkNumber(subjectData?.marks?.[markType][0], false, showExampt) + "\n" + formatMarkNumber(subjectData?.marks?.[markType][1], false, showExampt);
            }
          }
        }
        return "--.--";
      }

      const transformRowData = (row) => {
        return Object.entries(row).map(([key, value]) => ({
          content: value,
          styles: { ...bodyStyles, halign: key === "subjectName" ? "right" : "center" },
        }))
      }
      const validNumber = (value) => {
        return value != null && value !== "" && !isNaN(Number(value)) && Number(value) != undefined;
      }

      let finalTotal = 0;
      let totalCoef = 0;
      for (const [subjectData, subjectConfig] of tableRawData) {
        const exemptions = subjectData?.exemptions || null;
        const doesSubjectHasSubsubjects = Object.keys(subjectConfig.markTypesConfig).some(markType => subjectConfig.markTypesConfig[markType].subsubject) || false;
        const enabledMarkTypes = Object.keys(subjectConfig.markTypesConfig);
        const total = "--.--";
        let examptInAll = exemptions ? enabledMarkTypes.every(key => exemptions[key]) : false;

        if (validNumber(subjectData?.moyenne) && validNumber(subjectData?.coef)) {
          total = formatMarkNumber(subjectData?.moyenne * subjectData?.coef);
        }
        if (validNumber(total)) {
          finalTotal += Number(total);
        }
        totalCoef += subjectData?.coef;
        if (doesSubjectHasSubsubjects) {
          // groupby the subjectConfig array element by subjectConfig[].subsubject._id and perserve the object key
          const groupedSubjectConfig = {};

          // Iterate over each markType (key) and its config (value)
          Object.entries(subjectConfig.markTypesConfig).forEach(([markType, config]) => {
            if (config.subsubject && config.subsubject._id) {
              const subsubjectId = config.subsubject._id;

              // Initialize the group if it doesn't exist
              if (!groupedSubjectConfig[subsubjectId]) {
                groupedSubjectConfig[subsubjectId] = {
                  name: config.subsubject.name,
                  teacher: config.subsubject.teacher,
                  markType: []
                };
              }

              // Add the markType to the array and accumulate coef
              groupedSubjectConfig[subsubjectId].markType.push(markType);
            }
          });
          const subsubjectsArrays = Object.values(groupedSubjectConfig)
          // sort the subbject array with the most of markType.length
          subsubjectsArrays.sort((a, b) => b.markType.length - a.markType.length);

          for (const subsubjectConfig of subsubjectsArrays) {
            const row = {
              teacherRemarks: subsubjectConfig.teacher || "",
              total: "",
              rank: "",
              moy: examptInAll ? "معفی" : getMarkValue("moy", subjectData, subsubjectConfig.markType, enabledMarkTypes, true),
              synth: (examptInAll || exemptions?.synth) ? "معفی" : getMarkValue("synth", subjectData, subsubjectConfig.markType, enabledMarkTypes, true),
              cont2: (examptInAll || exemptions?.cont2) ? "معفی" : getMarkValue("cont2", subjectData, subsubjectConfig.markType, enabledMarkTypes, true),
              cont1: (examptInAll || exemptions?.cont1) ? "معفی" : getMarkValue("cont1", subjectData, subsubjectConfig.markType, enabledMarkTypes, true),
              written: (examptInAll || exemptions?.written) ? "معفی" : getMarkValue("written", subjectData, subsubjectConfig.markType, enabledMarkTypes, true),
              tp: (examptInAll || exemptions?.tp) ? "معفی" : getMarkValue("tp", subjectData, subsubjectConfig.markType, enabledMarkTypes, true),
              oral: (examptInAll || exemptions?.oral) ? "معفی" : getMarkValue("oral", subjectData, subsubjectConfig.markType, enabledMarkTypes, true),
              coef: "",
              subjectName: subsubjectConfig.name || "----",
            }
            tableData.push(transformRowData(row));
          }

          // add the total row of that subject
          const row = {
            teacherRemarks: subjectData.appreciation || "",
            total: examptInAll ? "معفی" : total,
            rank: examptInAll ? "مع" : formatMarkNumber(subjectsMinMaxAvg[subjectData?.subject?._id]?.rank || subjectData.rank),
            moy: examptInAll ? "معفی" : formatMarkNumber(subjectData.moyenne),
            synth: "--.--",
            cont2: "--.--",
            cont1: "--.--",
            written: "--.--",
            tp: "--.--",
            oral: "--.--",
            coef: formatMarkNumber(subjectData.coef, false),
            subjectName: subjectData?.subject?.name || "-",
          }
          tableData.push(transformRowData(row));

        }
        else {

          const row = {
            teacherRemarks: subjectData.appreciation || "",
            total: examptInAll ? "معفی" : total,
            rank: examptInAll ? "مع" : formatMarkNumber(subjectsMinMaxAvg[subjectData?.subject?._id]?.rank || subjectData.rank),
            moy: examptInAll ? "معفی" : formatMarkNumber(subjectData.moyenne),
            synth: (examptInAll || exemptions?.synth) ? "معفی" : getMarkValue("synth", subjectData, enabledMarkTypes, true),
            cont2: (examptInAll || exemptions?.cont2) ? "معفی" : getMarkValue("cont2", subjectData, enabledMarkTypes, true),
            cont1: (examptInAll || exemptions?.cont1) ? "معفی" : getMarkValue("cont1", subjectData, enabledMarkTypes, true),
            written: (examptInAll || exemptions?.written) ? "معفی" : getMarkValue("written", subjectData, enabledMarkTypes, true),
            tp: (examptInAll || exemptions?.tp) ? "معفی" : getMarkValue("tp", subjectData, enabledMarkTypes, true),
            oral: (examptInAll || exemptions?.oral) ? "معفی" : getMarkValue("oral", subjectData, enabledMarkTypes, true),
            coef: formatMarkNumber(subjectData.coef, false),
            subjectName: subjectData?.subject?.name || "-",
          }
          tableData.push(transformRowData(row));
        }
      }

      const emptybodyCell = {
        content: "",
        styles: headStyles,
      }

      const footerRow = [
        emptybodyCell,
        {
          content: formatMarkNumber(finalTotal),
          styles: { ...headStyles, fontSize: 9 },
        },
        emptybodyCell,
        emptybodyCell,
        emptybodyCell,
        emptybodyCell,
        emptybodyCell,
        emptybodyCell,
        emptybodyCell,
        emptybodyCell,
        {
          content: formatMarkNumber(totalCoef),
          styles: { ...headStyles, halign: "center", fontSize: 9 },
        },
        {
          content: "المجموع",
          styles: { ...headStyles, halign: "right", fontSize: 9 },
        }
      ]
      tableData.push(footerRow);

      doc.autoTable({
        startY: yPosition,
        body: tableData,
        theme: "grid",
        styles: {
          font: "Amiri",
          fontSize: 7,
          halign: "center",
        },
        cellPadding: 0,
        columnStyles: {
          0: { cellWidth: 50, halign: "center" }, // teacher remarks
          1: { cellWidth: 13, halign: "center" }, // total
          2: { cellWidth: 13, halign: "center" }, // rank
          3: { cellWidth: 13, halign: "center" }, // moy
          4: { cellWidth: 13, halign: "center" }, // synth
          5: { cellWidth: 11, halign: "center" }, // cont2
          6: { cellWidth: 11, halign: "center" }, // cont1
          7: { cellWidth: 11, halign: "center" }, // written
          8: { cellWidth: 15, halign: "center" }, // tp
          9: { cellWidth: 11, halign: "center" }, // oral
          10: { cellWidth: 11, halign: "center" }, // coef
          11: { cellWidth: 30, halign: "center" }, // subjectName
        },
        margin: { left: 5, right: 5 },
      });

      yPosition = 214;
      headStyles.fontSize = 10
      bodyStyles.fontSize = 10
      bodyStyles.fontStyle = "Bold"
      bodyStyles.fillColor = [245, 245, 245]


      const resultTableData = [
        [
          { content: "المواظبة", styles: bodyStyles, colSpan: 2 },
          { content: "العقوبات", styles: bodyStyles, colSpan: 4 },
          { content: "النتائج", styles: bodyStyles, colSpan: 5 },
        ],
        ['تأخر', 'غياب', 'مجلس', 'طرد', 'إنذار', 'المذاكرة', 'العقوبات', 'الجوائز', 'الرتبة', 'المعدل', 'الفترة'].map(
          (item) => ({
            content: item,
            styles: headStyles,
          })
        ),
        [
          { content: "", styles: bodyStyles },
          { content: "", styles: bodyStyles },
          { content: "", styles: bodyStyles },
          { content: "", styles: bodyStyles },
          { content: "", styles: bodyStyles },
          { content: "", styles: bodyStyles },
          { content: "", styles: bodyStyles },
          { content: bulletinData.certif || "--", styles: bodyStyles },
          { content: rank || "--", styles: bodyStyles },
          { content: bulletinData.generalMoyenne || "--", styles: bodyStyles },
          { content: trimesterNameAr || "", styles: bodyStyles },
        ]
      ]
      doc.autoTable({
        startY: yPosition,
        body: resultTableData,
        theme: "grid",
        margin: { left: 5 },
        columnStyles: {
          0: { cellWidth: 12, halign: "center" },
          1: { cellWidth: 12, halign: "center" },
          2: { cellWidth: 13, halign: "center" },
          3: { cellWidth: 10, halign: "center" },
          4: { cellWidth: 13, halign: "center" },
          5: { cellWidth: 16, halign: "center" },
          6: { cellWidth: 20, halign: "center" },
          7: { cellWidth: 30, halign: "center" },
          8: { cellWidth: 16, halign: "center" },
          9: { cellWidth: 20, halign: "center" },
          10: { cellWidth: 40, halign: "center" },
        },
      });

      yPosition = doc.lastAutoTable.finalY + 5;

      doc.rect(5, yPosition, 60, 35);
      doc.setFontSize(10);
      doc.setFont("Amiri", "normal");
      const directorGender = this.schoolDetails?.headMasterGender || "male";
      text = directorGender === "male" ? ":قرار مجلس القسم و ملاحظات المدير" : "قرار مجلس القسم و ملاحظات المديرة"
      doc.text(text, 10, yPosition + 5);

      doc.text(".........................................", 25, yPosition + 15);

      const directorName = this.schoolDetails?.headMaster || ".........................";
      const directorTitle = directorGender === "male" ? ":المدير" : ":المديرة";

      doc.setFont("Amiri", "Bold");
      doc.text(directorName, 25, yPosition + 25);
      textWidth = doc.getTextWidth(directorName);
      doc.setFont("Amiri", "normal");
      doc.text(directorTitle, 25 + textWidth, yPosition + 25);

      doc.rect(5, yPosition + 40, pdfWidth - 10, 10);
      const rlm = "\u200F"; // Right-to-Left Mark
      text = `ملاحظة: (---.--) لاعدد (غ ش) غياب شرعي (معفی) / (مع) معفی، (غ. م.) / (غم) غير مرتب، (ي) يوم، (س) ساعة (د) دقيقة`;

      doc.text(fixArabicParentheses(text), pdfWidth - 10, yPosition + 45, { align: 'right' });






      // Generate filename
      const studentNameForFile = student.fullName || student.fullNameFr || "Student";
      const filename = `Bulletin_${studentNameForFile.replace(/\s+/g, "_")}_T0${trimester}.pdf`;

      if (isMultipleStudents) {
        return doc
      }
      if (preview) {
        return doc.output("bloburl");
      } else {
        doc.save(filename);
      }
    },
    async generatePdfFr(data, studentId, trimester, preview = false, isMultipleStudents = null) {
      // Handle multiple students case - data is an array of student data
      let doc
      if (isMultipleStudents) {
        if (isMultipleStudents === true) {
          doc = new JsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
          });
          isMultipleStudents = doc;
        }
        else {
          doc = isMultipleStudents;
          doc.addPage();
        }
      }
      else {
        doc = new JsPDF({
          orientation: "portrait",
          unit: "mm",
          format: "a4",
        });
      }

      // Single student case - original logic
      const { bulletinData, bulletinConfig, averageMoyenne, minMoyenne, maxMoyenne, subjectsMinMaxAvg } = data;
      const { student, subjectMoyennes, generalMoyenne, trimester: dataTrimester, level } =
        bulletinData;

      const schoolYear = this.settings?.schoolarYears?.find(
        (el) => el._id === this.settings?.activeSchoolarYear
      );
      const startYear = schoolYear?.start ? new Date(schoolYear.start).getFullYear() : new Date().getFullYear();
      const endYear = schoolYear?.end ? new Date(schoolYear.end).getFullYear() : new Date().getFullYear() + 1;
      const schoolarYearName = `${startYear}/${endYear}`;      


      const pdfWidth = doc.internal.pageSize.getWidth();
      const pdfHeight = doc.internal.pageSize.getHeight();

      let xPosition = 5;
      let yPosition = 10;
      let text = "";
      let textWidth = 0;

      let fontSize = 14;
      let fontStyle = "Bold";
      let fontFamily = "Amiri";

      doc.setFont(fontFamily, fontStyle);
      doc.setFontSize(fontSize);

      // school logo top left

      const schoolLogo = await imageUrlToBase64(this.schoolDetails?.logo);
      if (schoolLogo) {
        doc.addImage(schoolLogo, "PNG", xPosition, yPosition, 30, 30);
      }
      // add border to the logo
      //doc.rect(xPosition, yPosition, 30, 30);
      xPosition += 32;
      yPosition += 5;

      // school name top left
      text = this.schoolDetails?.FrenchName || this.schoolDetails?.EnglishName || this.schoolDetails?.ArabicName || "";
      doc.text(text, xPosition, yPosition);
      doc.setFont("Amiri", "normal");
      // address
      yPosition += 7.5;
      text = this.schoolDetails?.adress || "";
      doc.text(text, xPosition, yPosition);
      yPosition += 7.5;
      // phone
      text = String(this.schoolDetails?.phone) || "";
      doc.text(text, xPosition, yPosition);
      yPosition += 7.5;
      // email
      text = this.schoolDetails?.email || "";
      doc.text(text, xPosition, yPosition);

      // class info
      yPosition = 15
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(14);
      doc.rect(pdfWidth / 2, 10, pdfWidth / 2 - 5, 20);
      const rectCenterX = (pdfWidth / 2) + (pdfWidth / 2 - 5) / 2;
      text = `Classe de ${level}${level == 10 ? "ère" : "ème"} ${bulletinData.classroomName}`
      textWidth = doc.getTextWidth(text);
      doc.text(text, rectCenterX - textWidth / 2, yPosition);
      // schoolar year
      doc.setFont("Amiri", "normal");
      yPosition += 6.5;
      text = `Année scolaire: ${schoolarYearName}`;
      textWidth = doc.getTextWidth(text);
      doc.text(text, rectCenterX - textWidth / 2, yPosition);
      // trimester
      yPosition += 6.5;
      text = `Bulletin du ${trimester}${trimester == 1 ? "ère" : "ème"} Trimestre`;
      textWidth = doc.getTextWidth(text);
      doc.text(text, rectCenterX - textWidth / 2, yPosition);

      // time and date
      doc.setFontSize(10);
      yPosition = 35;
      text = moment().format("DD/MM/YYYY HH:mm");
      textWidth = doc.getTextWidth(text);
      doc.text(text, pdfWidth - textWidth - 7, yPosition);


      // student info
      yPosition = 50;
      xPosition = 5;
      doc.rect(xPosition, yPosition, pdfWidth / 2 - 5, 30);
      yPosition += 5;
      xPosition += 2;
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(14);
      text = student.fullNameFr || student.fullName || "----";
      doc.text(text, xPosition, yPosition);
      doc.setFont("Amiri", "normal");
      doc.setFontSize(11);
      yPosition += 7.5;
      text = `Née le ${student.birthDate ? moment(student.birthDate).format("DD/MM/YYYY") : "--/--/----"}`;
      doc.text(text, xPosition, yPosition);
      // parent info
      yPosition = 55;
      xPosition = pdfWidth / 2 + 5;
      /// father info
      doc.setFont("Amiri", "Bold");
      doc.setFontSize(12);
      text = `Mr ${student.fatherFirstName} ${student.fatherLastName}`;
      doc.text(text, xPosition, yPosition);
      yPosition += 7.5;
      doc.setFont("Amiri", "normal");
      text = student.fatherAddress || "---- --";
      doc.text(text, xPosition, yPosition);


      // marks tables
      const headStyles = {
        font: "Amiri",
        fontSize: 10,
        fontStyle: "normal",
        fillColor: [255, 255, 255],
        lineColor: [0, 0, 0],
      }
      let body = [
        [
          { content: "Matière", styles: headStyles, rowSpan: 2 },
          { content: "Moyenne", styles: headStyles, colSpan: 4 },
          { content: "Appréciation / Conseils", styles: headStyles, rowSpan: 2 },
        ],
        [
          { content: "Elève", styles: { ...headStyles, fillColor: [255, 255, 224] } },
          { content: "Min.", styles: headStyles },
          { content: "Classe", styles: headStyles },
          { content: "Max.", styles: headStyles },
        ]
      ]
      const bodyStyles = {
        font: "Amiri",
        fontSize: 9,
        fontStyle: "normal",
        fillColor: [255, 255, 255],
        lineColor: [0, 0, 0],
        halign: "center",
        valign: "middle",
      }
      const boldBodyStyles = {
        font: "Amiri",
        fontSize: 9,
        fontStyle: "Bold",
        fillColor: [255, 255, 255],
        lineColor: [0, 0, 0],
        halign: "center",
        valign: "middle",
      }
      for (const subject of subjectMoyennes) {
        const subjectTitle = (subject.subject.nameFr || subject.subject.name || "----") + `\n` + (subjectsMinMaxAvg[subject.subject._id]?.teacherName || "------");
        body.push([
          { content: subjectTitle, styles: { ...boldBodyStyles, halign: "left" } },
          { content: formatMarkNumber(subject.moyenne), styles: { ...boldBodyStyles, fillColor: [255, 255, 224] } },
          { content: formatMarkNumber(subjectsMinMaxAvg[subject.subject._id].min), styles: bodyStyles },
          { content: formatMarkNumber(subjectsMinMaxAvg[subject.subject._id].average), styles: bodyStyles },
          { content: formatMarkNumber(subjectsMinMaxAvg[subject.subject._id].max), styles: bodyStyles },
          { content: subject.appreciation || "", styles: bodyStyles },
        ])
      }

      const footerStyles = {
        font: "Amiri",
        fontSize: 9,
        fontStyle: "normal",
        fillColor: [224, 224, 224],
        lineColor: [0, 0, 0],
        halign: "center",
        valign: "middle",
      }
      body.push([
        { content: "Moy.gén.annuelle", styles: footerStyles },
        { content: formatMarkNumber(averageMoyenne), styles: { ...footerStyles, fontStyle: "Bold" } },
        { content: formatMarkNumber(minMoyenne), styles: footerStyles },
        { content: formatMarkNumber(averageMoyenne), styles: footerStyles },
        { content: formatMarkNumber(maxMoyenne), styles: footerStyles },
        { content: `P.${trimester}: ${formatMarkNumber(averageMoyenne)}`, styles: footerStyles },
      ])
      yPosition = 85;
      doc.autoTable({
        startY: yPosition,
        body: body,
        theme: "grid",
        columnStyles: {
          0: { cellWidth: 50, halign: "center" },
          1: { cellWidth: 15, halign: "center" },
          2: { cellWidth: 15, halign: "center" },
          3: { cellWidth: 15, halign: "center" },
          4: { cellWidth: 15, halign: "center" },
          5: { cellWidth: 90, halign: "center" },
        },
        margin: { left: 5, right: 5 },
      });

      doc.setFont("Amiri", "Bold");
      doc.setFontSize(8);
      text = `Bulletin à conserver précieusement. Aucun duplicata ne sera délivré. ${bulletinData.classroomName} - ${schoolarYearName}`
      textWidth = doc.getTextWidth(text);
      doc.text(text, pdfWidth / 2 - textWidth / 2, pdfHeight - 5);
      doc.rect(5, pdfHeight - 35, pdfWidth / 2 + 10, 25);
      doc.setFont("Amiri", "normal");
      text = "Avis du Conseil de classe :";
      doc.text(text, 7, pdfHeight - 32);
      text = this.schoolDetails?.headMasterFrench || this.schoolDetails?.headMasterArabic || ".........................";
      doc.text(text, pdfWidth / 2 + 20, pdfHeight - 32);
      const studentNameForFile = student.fullName || student.fullNameFr || "Student";
      const filename = `Bulletin_${studentNameForFile.replace(/\s+/g, "_")}_T0${trimester}.pdf`;
      if (isMultipleStudents) {
        return doc
      }
      if (preview) {
        return doc.output("bloburl");
      } else {
        doc.save(filename);
      }
    },
  }
};
